import styled, { css } from "styled-components";

import Button from "core/Button";
import Messages from "core/Messages";

import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
import { textSm, medium as mediumFontStyle } from "core/fontStyles";
import { spacingWithBreakpoints } from "core/spacing";
import {
    BorderBottomLinkStyle,
    CustomFocusStyle,
    BorderBottomLink
} from "core/Typography";
import AttributionAreaBasicDesktop from "icons/AttributionBacklink/AttributionAreaBasicDesktop";
import { IconButton } from "icons/AttributionBacklink/styles";

import { rapidEasing } from "core/animation";

export const DownloadButtonsContainer = styled.div`
    margin-top: ${convertPxToRem({ px: 24 })};
`;

export const DownloadButton = styled(Button).attrs({
    styleType: "cta",
    darkMode: true,
    width: "100%"
})`
    &:first-of-type {
        margin-bottom: ${convertPxToRem({ px: 24 })};
    }
`;

export const DownloadSize = styled.div`
    display: flex;
    justify-content: center;
    color: ${colors.primary.diamond};
    ${textSm}
    ${spacingWithBreakpoints.SMTop}
`;

export const CurrentDownloadSize = styled.div`
    flex: 0 0 auto;
`;

export const ChangeDownloadSize = styled.div`
    flex: 0 0 auto;
    margin-left: ${convertPxToRem({ px: 8 })};
`;

export const linkStyle = css`
    background-color: transparent;
    padding: 0;
    border: none;
    ${BorderBottomLinkStyle}
    color: ${colors.accent.darkMode.suenosBuenos};
    border-bottom-color: ${colors.accent.darkMode.suenosBuenos};

    &:hover {
        color: ${colors.primary.diamond};
        border-bottom-color: ${colors.primary.diamond};
    }
`;

export const OpenSizeOptions = styled.button`
    ${linkStyle}
    ${mediumFontStyle}
    font-size: ${convertPxToRem({ px: 12 })};
    cursor: pointer;
`;

export const ChangeDownloadSizeItem = styled.button`
    ${linkStyle}
    color: ${colors.secondary.oolong};
    border-bottom-color: ${colors.secondary.oolong};

    &:hover {
        color: ${colors.secondary.cosmic};
        border-bottom-color: ${colors.secondary.cosmic};
    }
`;

export const BackLink = styled.button`
    ${linkStyle}
    font-size: ${convertPxToRem({ px: 12 })};
`;

export const ErrorMessage = styled(Messages).attrs({
    darkMode: true,
    isDismissable: true,
    infoType: "error",
    styleType: "solid"
})`
    margin-top: ${convertPxToRem({ px: 30 })};
`;

export const Divider = styled.hr`
    display: block;
    background-color: ${colors.accent.darkMode.suenosBuenos};
    height: ${convertPxToRem({ px: 1 })};
    border: 0;
`;

export const Link = styled.a`
    ${BorderBottomLinkStyle}
    color: ${colors.accent.darkMode.suenosBuenos};
    border-color: ${colors.accent.darkMode.suenosBuenos};
    transition: color ${rapidEasing}, border-bottom-color ${rapidEasing};
    &:hover {
        color: ${colors.primary.diamond};
        border-color: ${colors.primary.diamond};
    }
    ${CustomFocusStyle}
`;

export const IconDetailDownloadContainer = styled.div`
    ${AttributionAreaBasicDesktop} {
        margin-top: ${convertPxToRem({ px: 24 })};
    }

    ${Divider} {
        margin-top: ${convertPxToRem({ px: 24 })};
        margin-bottom: ${convertPxToRem({ px: 16 })};
    }

    ${IconButton} {
        margin-left: ${convertPxToRem({ px: 8 })};
    }
`;

export const DownloadMessageSecondaryText = styled.p`
    color: ${colors.secondary.dolphin};

    ${BorderBottomLink} {
        margin-left: ${convertPxToRem({ px: 4 })};
    }
`;

export const UnstyledDownloadMessage = styled.div`
    ${DownloadMessageSecondaryText} {
        padding-left: ${convertPxToRem({ px: 36 })};
        margin-top: -${convertPxToRem({ px: 3 })};
    }
`;

export const MessageAndButtonContainer = styled.div`
    position: relative;
    z-index: 1;
    background-color: ${colors.secondary.orca};
`;

export const SecondaryContentContainer = styled.div`
    position: relative;
    z-index: 0;
`;
